module.exports = __webpack_public_path__ + "static/img/アセット 9@2x.2b33033.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/meal_entry/アセット 9@2x.png
// module id = EBKv
// module chunks = 1